import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { isBlackFridayPopupActive } from "utils/dateUtils"
import { ENABLE_BLACK_FRIDAY_POPUP } from "config/campaignFeatureToggles"
import "./BlackFridayPopup.scss"

const BlackFridayPopup = () => {
  const [isVisible, setIsVisible] = useState(true)
  const history = useHistory()

  const STORAGE_KEY = "blackFridayPopup2025Dismissed"

  useEffect(() => {
    const wasClosed = sessionStorage.getItem(STORAGE_KEY)
    if (wasClosed === "true") {
      setIsVisible(false)
    }
  }, [])

  // Check feature toggle and date conditions
  if (!ENABLE_BLACK_FRIDAY_POPUP) return null
  if (!isBlackFridayPopupActive()) return null
  if (!isVisible) return null

  const handleClose = () => {
    setIsVisible(false)
    sessionStorage.setItem(STORAGE_KEY, "true")
  }

  const handleViewProducts = () => {
    const blackFridayUrl = '/shop/productlist?filters=%7B"FLT-CATEG001"%3A%5B"%2327616"%5D%7D&page=1&sortBy=ranking'
    history.push(blackFridayUrl)
    handleClose()
  }

  return (
    <div className="black-friday-popup">
      <div className="black-friday-popup__header">
        <h4 className="black-friday-popup__title">
          🔥 A început Black Friday!
        </h4>
        <button
          onClick={handleClose}
          className="black-friday-popup__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div className="black-friday-popup__content">
        <p>
          Ai peste 1.280 de produse reduse cu până la 62%. Grăbește-te, stocurile se epuizează rapid!
        </p>
        <button
          onClick={handleViewProducts}
          className="black-friday-popup__cta-button"
        >
          Vezi produsele
        </button>
      </div>
    </div>
  )
}

export default BlackFridayPopup
